<template>
	<div class="message">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "MessageBlock"
}
</script>

